export default "__VITE_ASSET__BJv3jSF___"